export const shopType = {
    PARDAKHT_SHAKHSI:            1,
    BUSINESS:                    2,
    SERVICES:                    3,
    BUSINESS_PSP_SETTLEMENT:     4,
}

export const shopTypeStr = {
    PARDAKHT_SHAKHSI: "لینک پرداخت",
    BUSINESS: "پرداخت‌یاری",
    SERVICES: "پرداخت یاری",
    BUSINESS_PSP_SETTLEMENT: "پرداخت‌یاری-تسویه مستقیم",

    get(status)
    {
        let status_str = null;

        Object.keys(shopType).forEach(item => {
            if (shopType[item] === status) {
                status_str = shopTypeStr[item];
            }
        })

        return status_str;
    }
}
